import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { BrandModel } from '../models/brand.model';

export class BrandsApiService extends ApiService {
  static endpoint = 'brands';

  /**
   * @param {String} brandId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<BrandModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(), {
      ...config,
      dataModel: BrandModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
